import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4912e71f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "tyre_range_tabs p-0",
  id: "wheelBrands"
}
const _hoisted_2 = {
  class: "nav nav-tabs",
  id: "myTab",
  role: "tablist"
}
const _hoisted_3 = ["id", "data-bs-target", "aria-controls", "onClick"]
const _hoisted_4 = { class: "thumb_wrap" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_8 = ["id", "aria-labelledby"]
const _hoisted_9 = ["id"]
const _hoisted_10 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_11 = ["id", "data-bs-target", "aria-controls"]
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = ["id"]
const _hoisted_14 = ["id", "aria-labelledby"]
const _hoisted_15 = { class: "wrapper top_content" }
const _hoisted_16 = { class: "container" }
const _hoisted_17 = { class: "row wheel" }
const _hoisted_18 = { class: "slider" }
const _hoisted_19 = ["id"]
const _hoisted_20 = { class: "carousel-inner" }
const _hoisted_21 = ["data-fancybox", "href"]
const _hoisted_22 = ["src", "alt"]
const _hoisted_23 = { class: "carousel-indicators" }
const _hoisted_24 = ["data-bs-target", "data-bs-slide-to", "aria-label"]
const _hoisted_25 = { class: "text" }
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = {
  key: 0,
  class: "list_square"
}
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "divider my-4" })
], -1))

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tyreList, (row, index) => {
        return (_openBlock(), _createElementBlock("li", {
          class: _normalizeClass(["nav-item", 'tabs-'+ _ctx.tyreList.length]),
          role: "presentation"
        }, [
          _createElementVNode("button", {
            class: _normalizeClass(["nav-link", index== 0 ?'active' :'']),
            id: 'w'+row.name.replace(' ', '-')+'-tab',
            "data-bs-toggle": "tab",
            "data-bs-target": '#'+'w'+row.name.replace(' ', '-'),
            type: "button",
            role: "tab",
            "aria-controls": 'w'+row.name.replace(' ', '-'),
            "aria-selected": "true",
            onClick: $event => (_ctx.openInfo(row.name))
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("img", {
                src: _ctx.getImgUrl(row.image),
                alt: row.name
              }, null, 8, _hoisted_5),
              (row.tyre_image)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.getImgUrl(row.tyre_image),
                    alt: "tyre",
                    class: "img-fluid tyre"
                  }, null, 8, _hoisted_6))
                : _createCommentVNode("", true),
              _createElementVNode("span", null, _toDisplayString(row.name), 1)
            ])
          ], 10, _hoisted_3)
        ], 2))
      }), 256))
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tyreList, (row, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["tab-pane fade", index== 0 ?'active show' :'']),
          id: 'w'+row.name.replace(' ', '-'),
          role: "tabpanel",
          "aria-labelledby": 'w'+row.name.replace(' ', '-')+'-tab'
        }, [
          (row.typeCount > 0)
            ? (_openBlock(), _createElementBlock("ul", {
                key: 0,
                class: "nav nav-tabs",
                id: 'myTabInner'+index,
                role: "tablist"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.tyreType, (type, n) => {
                  return (_openBlock(), _createElementBlock("li", _hoisted_10, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["nav-link", n == 0 ?'active' :'']),
                      id: type.name+'-tab',
                      "data-bs-toggle": "tab",
                      "data-bs-target": '#'+type.name,
                      type: "button",
                      role: "tab",
                      "aria-controls": type.name,
                      "aria-selected": "true"
                    }, [
                      _createElementVNode("span", {
                        innerHTML: type.title
                      }, null, 8, _hoisted_12)
                    ], 10, _hoisted_11)
                  ]))
                }), 256))
              ], 8, _hoisted_9))
            : _createCommentVNode("", true),
          (row.typeCount > 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "tab-content ss",
                id: 'myTabInnerContent'+index
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.tyreType, (type, n) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["tab-pane fade", n == 0 ?'active show' :'']),
                    id: type.name,
                    role: "tabpanel",
                    "aria-labelledby": type.name
                  }, [
                    _createElementVNode("section", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(type.wheels, (wheel, o) => {
                          return (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["d-flex align-items-center", wheel.video ? 'col-md-6 col-lg-3' : 'col-12 col-md-6'])
                            }, [
                              _createElementVNode("div", _hoisted_18, [
                                _createElementVNode("div", {
                                  id: type.name+n+o,
                                  class: "carousel slide"
                                }, [
                                  _createElementVNode("div", _hoisted_20, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(wheel.slider, (slide, i) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        class: _normalizeClass(["carousel-item", i == 0 ?'active' :'']),
                                        "data-interval": "1000"
                                      }, [
                                        _createElementVNode("a", {
                                          "data-fancybox": _ctx.getImgUrl(slide.image),
                                          href: _ctx.getImgUrl(slide.image)
                                        }, [
                                          _createElementVNode("img", {
                                            src: _ctx.getImgUrl(slide.image),
                                            class: "d-block w-100",
                                            alt: slide.alt
                                          }, null, 8, _hoisted_22)
                                        ], 8, _hoisted_21)
                                      ], 2))
                                    }), 256))
                                  ]),
                                  _createElementVNode("div", _hoisted_23, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(wheel.slider, (slide, i) => {
                                      return (_openBlock(), _createElementBlock("button", {
                                        type: "button",
                                        "data-bs-target": '#'+type.name+n+o,
                                        "data-bs-slide-to": i,
                                        class: _normalizeClass(i == 0 ?'active' :''),
                                        "aria-current": "true",
                                        "aria-label": 'Slide'+i
                                      }, null, 10, _hoisted_24))
                                    }), 256))
                                  ])
                                ], 8, _hoisted_19)
                              ])
                            ], 2),
                            _createElementVNode("div", {
                              class: _normalizeClass(["d-flex align-items-center", wheel.video ? 'col-md-12 col-lg-6' : 'col-md-6'])
                            }, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["text_wrapper", {'has-video': wheel.video}])
                              }, [
                                _createElementVNode("div", _hoisted_25, [
                                  _createElementVNode("h2", {
                                    class: "title",
                                    innerHTML: wheel.title
                                  }, null, 8, _hoisted_26),
                                  (wheel.features)
                                    ? (_openBlock(), _createElementBlock("ul", _hoisted_27, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(wheel.features, (fs) => {
                                          return (_openBlock(), _createElementBlock("li", { innerHTML: fs }, null, 8, _hoisted_28))
                                        }), 256))
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ], 2)
                            ], 2),
                            _hoisted_29
                          ]))
                        }), 256))
                      ])
                    ])
                  ], 10, _hoisted_14))
                }), 256))
              ], 8, _hoisted_13))
            : _createCommentVNode("", true)
        ], 10, _hoisted_8))
      }), 256))
    ])
  ]))
}